import * as React from 'react';
import { Fragment } from 'react';
import { IUnderwriterRemittanceData } from '../../../../../../types/order/escrow/IUnderwriterRemittanceData';
import { BodyText, BoldBodyText, Currency } from 'ui-toolkit';
import { sum } from 'lodash';
import styled from 'styled-components';
import { ICDV3ViewItem } from '../../../../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { generateDisplayLabel } from '../../../../../../ui-toolkit/cdItems/data/generateDisplayLabel';
import { eTitleFees } from '../../../../../../ui-toolkit/enums/eTitleFees';
import { eCDV3ItemTypes } from '../../../../../../ui-toolkit/enums/eCDV3ItemTypes';

interface IRevenueListItem {
  amount: number;
  id: string;
  label: string | null;
}

const FeeError = styled.span`
  color: ${(props) => props.theme.colors.errorText};
`;

export interface IRevenueCalculationProps {
  cdItems: ICDV3ViewItem[];
  underwriterRemittances: IUnderwriterRemittanceData[];
  isSprucePowered: boolean | undefined;
}

export const RevenueCalculation: React.FC<IRevenueCalculationProps> = ({
  cdItems,
  underwriterRemittances,
  isSprucePowered,
}) => {
  const nonRemittedRevenueItems = cdItems.filter(
    (cdItem) =>
      cdItem.type === eCDV3ItemTypes.title_fee &&
      (cdItem.sub_type === eTitleFees.coordination ||
        cdItem.sub_type === eTitleFees.closing ||
        cdItem.sub_type === eTitleFees.settlement)
  );
  const nonZeroRemittances = underwriterRemittances.filter(
    (underwriterRemittance) => underwriterRemittance.spruceFeeAmountCents
  );
  const listItems: IRevenueListItem[] = [
    ...nonZeroRemittances.map(({ cdItemsV3Id, id, spruceFeeAmountCents }) => {
      const cdItem = cdItems.find((cdItem) => cdItem.id === cdItemsV3Id);
      const label = cdItem ? generateDisplayLabel(cdItem) : 'FEE ERROR';
      return { amount: spruceFeeAmountCents / 100, id, label };
    }),
    ...nonRemittedRevenueItems.map((cdItem) => ({
      amount:
        (cdItem.buyer_at_closing || 0) +
        (cdItem.buyer_before_closing || 0) +
        (cdItem.seller_at_closing || 0) +
        (cdItem.seller_before_closing || 0) +
        (cdItem.paid_by_others || 0),
      id: cdItem.id,
      label: generateDisplayLabel(cdItem),
    })),
  ];
  return (
    <div>
      <BodyText>
        {isSprucePowered ? 'SprucePowered Client Revenue: ' : 'Estimated Spruce Revenue: '}
        <BoldBodyText as="span">
          <Currency value={sum(listItems.map((item) => item.amount))} />
        </BoldBodyText>
      </BodyText>
      {!isSprucePowered && (
        <BodyText>
          {"Includes revenue for Spruce's portion of: "}
          {listItems.map(({ amount, id, label }, index) => {
            return (
              <Fragment key={id}>
                {index > 0 ? ', ' : null}
                {label === 'FEE ERROR' ? <FeeError>{label}</FeeError> : label}{' '}
                <BoldBodyText as="span">
                  <Currency value={amount} />
                </BoldBodyText>
              </Fragment>
            );
          })}
        </BodyText>
      )}
    </div>
  );
};
